import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import { hasDatasharesPermissions } from "@services/useDatasharesPermissions";

import type { I18nT } from "@lib/dashboardI18n";
import { isDeltashareAvailable } from "@lib/datashares/isDeltashareAvailable";

const DatabricksDeltashareForNro = lazy(() =>
  import("@scenes/DatasharesIntegration/DatabricksDeltashareForNro").then((module) => ({
    default: module.DatabricksDeltashareForNro,
  }))
);

export const databricksDeltashareNRO: NavigationRoutingObject = {
  Component: DatabricksDeltashareForNro,
  componentFeatureFlippers: ["datashares_integrations", "datashares_integration_nro_component"],
  section: "partner-integrations",
  heading: (t: I18nT<"dashboard-navigation">) => t("datashares-sidebar-pill-menu-option", "Data Sharing"),
  pageNameForTracking: () => "Data Sharing",
  icon: "nav-system-data-sharing",
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission }) => {
    return (
      featureOn("datashares_integrations") &&
      isDeltashareAvailable(featureOn) &&
      hasDatasharesPermissions({ hasPermission }).canViewDatashares
    );
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/integrations/datashares_integrations/:appGroupId",
};
